import { useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";

export default function LocalizedRoute({ lang, children }) {
  const { setLang } = useLanguage();
  useEffect(() => { setLang(lang); }, [lang, setLang]);
  return children;
}
